import {
  localStoreKey,
  localStoreKeyAccessToken,
  localStoreKeyRefreshToken,
} from '../store/slices/authorizationSlice';

/**
 * Clears all auth data from localStorage and redirects to sign-in.
 *
 * Called from both the RTK Query base query wrapper and the axios interceptor
 * so there is one canonical "force logout" path regardless of which HTTP
 * layer detected the 401.
 *
 * Uses window.location.replace so the sign-in page is not added to the
 * browser history — the user cannot go "back" to an authenticated view.
 */
export const handleUnauthorized = (): void => {
  localStorage.removeItem(localStoreKey);
  localStorage.removeItem(localStoreKeyAccessToken);
  localStorage.removeItem(localStoreKeyRefreshToken);
  localStorage.removeItem('dynamic');

  if (!window.location.pathname.includes('sign-in')) {
    window.location.replace('/login/sign-in');
  }
};
